import { secondBetweenTimestamps, TranscriptEntry } from "@neum/frontend-shared/utils/textUtils"

type TranscriptProps = {
    startTimestamp: string | undefined
    entries: TranscriptEntry[]
    setCurrentTime: (time_s: number) => void
}

export function Transcript({ entries, startTimestamp, setCurrentTime }: TranscriptProps) {
  return (
    <div className="rounded-lg border bg-card text-card-foreground shadow-sm">
      <div className="p-4">
        <div className="mt-2 max-h-[400px] overflow-y-auto">
          {entries.map((entry, index) => (
            <div key={index} className="mb-3 last:mb-0 hover:bg-blue-50 rounded-md p-2 transition-colors duration-200 cursor-pointer" onClick={() => {setCurrentTime(secondBetweenTimestamps(startTimestamp ?? '', entry.timestamp_full))}}>
                <div className="flex sm:flex-row flex-col items-start gap-x-4 gap-y-4">
                    <span className="whitespace-nowrap text-sm font-medium text-muted-foreground border rounded-full px-2 bg-blue-50 text-gray-600">{entry.timestamp}</span>
                    <span className="text-sm text-gray-800">{entry.text}</span>
                </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
